const nativeReplace = (redirectUrl: string) => {
  const regex = /[^a-z0-9\]\[\\\-_/#?=]/gi;
  const sanitizedRedirect = (redir: string) => redir.replaceAll(regex, '');
  const path = redirectUrl.length ? sanitizedRedirect(redirectUrl) : '/';
  return location.replace(path);
};

export default nativeReplace;
